<template>
  <div class="text-center dishes__slider">
    <vueper-slides
      fade
      autoplay
      :fixed-height="true"
      class="no-shadow"
      :visible-slides="1"
      :arrows-outside="false"
      :bullets="false"
      :infinite="true"
      :dragging-distance="100"
      :touchable="true"
      :disable-arrows-on-edges="true"
      
    >
      <template #arrow-left>
        <img src="@/assets/images/icons/prev.png">
      </template>

      <template #arrow-right>
        <img src="@/assets/images/icons/next.png">
      </template>
      <vueper-slide
        v-for="(slide, i) in slides"
        :key="i"
        :image="`https://api.rewolucyjna.pl/cms/${slide.img}`"
        :title="slide.text"
      >
        <template #content>
          <div class="vueperslide__content-wrapper">
            <div class="vueperslide__text" v-html="slide.text">
           
            </div>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "Slider",
    inject: ["content"],
  data() {
    return {
      title: "Slider",
      slides:  this.content.data.dishes.slides,
    };
  },
  components: { VueperSlides, VueperSlide },
};
</script>
